import React, { useState } from 'react';
import { Marker } from 'react-map-gl';
import { SearchResultPractice } from '../types';
import { MapPracticeCard, Pin } from './SearchMap.styles';

interface Props {
  practice: SearchResultPractice;
}

export const MapMarker = ({ practice }: Props) => {
  const [showingCard, setShowingCard] = useState(false);

  if (!practice.address) return null;

  return (
    <Marker
      latitude={practice.address.latitude}
      longitude={practice.address.longitude}
      onClick={() => setShowingCard(!showingCard)}
    >
      <Pin />
      {showingCard && <MapPracticeCard practice={practice} />}
    </Marker>
  );
};
